
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b474d594!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PriceRange.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PriceRange.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-b474d594!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PriceRange.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/PriceRange.vue
// module id = 197
// module chunks = 2